import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DefaultFrameComponent } from '../../../frames/default-frame/default-frame.component';

@Component({
    selector: 'kaz-fundamentals',
    templateUrl: './fundamentals.component.html',
    styleUrls: ['./fundamentals.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DefaultFrameComponent]
})
export class FundamentalsComponent {

}
